import buildPrefixedClassToken from './build-prefixed-class-token';
import removeClassTokens from './remove-class-tokens';

const upsertClassToken = (classString, { prefix = null, matchesToken, token }) => {
  const preservedTokens = removeClassTokens(classString, { prefix, matchesToken });
  const nextToken = buildPrefixedClassToken(token, prefix);

  return preservedTokens ? `${preservedTokens} ${nextToken}` : nextToken;
};

export default upsertClassToken;
